import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'app/components';
import TicketBuilder from './ticketBuilder';
// import VenueDetails from './venueDetails';
import EventDetails from './eventDetails';
import { createEvent, getCitiesList, getEvent, getVenueList, updateEvent } from './api';
// import { SIDEBAR_MENU_LIST } from './constants';
import { uploadImage } from '../../event-create/api';
import './style';
import { deleteEvent } from '../events-list/api';
import { IMAGE_TAGS } from '../../../constants/imageTags';

const Footer = ({ hasDelete, primaryLabel, onClickPrimary, onClickSecondary }) => (
  <div className="flex gap-4 mx-auto mt-10">
    {hasDelete && (
      <Button
        type="secondary"
        onClick={onClickSecondary}
      >
        Delete
      </Button>)}
    <Button onClick={onClickPrimary}>
      {primaryLabel}
    </Button>
  </div>
);

// const TicketDetails = (props) => {
//   const {
//     eventData,
//     onChange,
//   } = props;

//   return (
//     <div className="event-details-form flex flex-col gap-10">
//       <TicketBuilder
//         tickets={eventData?.tickets}
//         onChange={(tickets) => onChange({ tickets })}
//       />
//     </div>
//   );
// };

const EventCreate = () => {
  // const [activeSection, setActiveSection] = useState('details');
  const [unsavedData, setUnsavedData] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false); 

  const { eventData } = useSelector((state) => state.adminEventCreate);

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getVenueList();
    getCitiesList();

    return () => dispatch({ type: 'ADMIN_EVENT_CREATE:RESET' });
  }, []);

  useEffect(() => {
    if (params?.id) {
      getEvent(params.id);
    }
  }, [params?.id]);

  useEffect(() => {
    setUnsavedData(eventData);
  }, [eventData]);

  const onChange = (data) => {
    setUnsavedData((prev) => ({ ...prev, ...data }));
  };

  const navigateBack = () => navigate('/admin/events');

  const saveEvent = (data) => {
    if (params?.id) {
      updateEvent(params.id, data, navigateBack);
    } else createEvent(data, navigateBack);
  };

  const onSave = () => {
    if (unsavedData?.image instanceof File) {
      uploadImage({
        image: unsavedData.image,
        id: eventData?.image ?? null,
        tag: IMAGE_TAGS.EVENT_IMAGE,
        fileName: `${eventData?.id}_${IMAGE_TAGS.EVENT_IMAGE}`,
      }).then((resp) => {
        const imageId = resp?.data?.data?.url;
        saveEvent({
          ...unsavedData,
          image: imageId,
        });
      });
    } else saveEvent(unsavedData);
  };

  const onDeleteEvent = () => {
    deleteEvent(params?.id, () => {
      navigate('../admin/events');
      setShowDeleteConfirmation(false);
    });
  };

  return (
    <div className="flex admin-event-create">
      {/* <Sidebar
        menuItems={SIDEBAR_MENU_LIST}
        onMenuClick={(item) => setActiveSection(item.value)}
        selectedItem={activeSection}
        colorMode="black"
      /> */}
      <div className="content-wrapper flex-1 flex flex-col justify-between gap-4 py-5 px-10">
        <EventDetails
          eventData={unsavedData}
          onChange={onChange}
        />
        {/* {activeSection === 'ticket-details' && (
          <TicketDetails 
            eventData={unsavedData}
            onChange={onChange}
          />)} */}
        <Footer
          hasDelete={!!params?.id}
          primaryLabel={!!params?.id ? 'Save' : 'Create'}
          onClickPrimary={onSave}
          onClickSecondary={() => setShowDeleteConfirmation(true)}
        />
        <Modal
          className="delete-confirmation-modal"
          primaryText="Delete"
          size="regular"
          isOpen={showDeleteConfirmation}
          onClickPrimaryCta={onDeleteEvent}
          onClickSecondaryCta={() => setShowDeleteConfirmation(false)}
          title="Are you sure you want to delete this event?"
        />
      </div>
    </div>
  );
};

export default EventCreate;
